// extracted by mini-css-extract-plugin
module.exports = {"container":"room__SelfRegistratrionFormContainer__container___2Ls8Ee"};